import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card border-0 rounded-0 bg-white authentication-card",
  style: {"margin-top":"30% !important","border-radius":"15px !important","width":"500px","height":"auto"}
}
const _hoisted_2 = {
  class: "card-body letter-spacing",
  style: {"padding":"60px 50px !important"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "text-black fw-bold mb-0 text-center" }, " Veuillez vous connecter! ", -1)
const _hoisted_4 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Identifiant ", -1)
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot de passe ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-between mb-15 mb-md-20" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-muted lh-1" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input shadow-none",
      type: "checkbox",
      id: "remember-me"
    }),
    /*#__PURE__*/_createElementVNode("label", {
      class: "form-check-label",
      for: "remember-me"
    }, " Se souvenir de moi ")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100",
  type: "submit"
}, " Se connecter ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Form, {
        ref: "elementForm",
        onSubmit: _ctx.addElement,
        "validation-schema": _ctx.elementSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_Field, {
              name: "identifiant",
              type: "text",
              class: "form-control shadow-none fs-md-15 text-black",
              placeholder: "Entrer votre identifiant u votre mail"
            }),
            _createVNode(_component_ErrorMessage, {
              name: "identifiant",
              class: "text-danger"
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_Field, {
              name: "password",
              type: "password",
              class: "form-control shadow-none fs-md-15 text-black",
              placeholder: "Entrer votre email ouu identifiant"
            }),
            _createVNode(_component_ErrorMessage, {
              name: "password",
              class: "text-danger"
            })
          ]),
          _hoisted_8,
          _hoisted_9
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}